import { render, staticRenderFns } from "./Science.vue?vue&type=template&id=9d266208&"
import script from "./Science.vue?vue&type=script&lang=js&"
export * from "./Science.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports